<template v-slot="color">
    <div id="post-small-block" class="post-block-style clearfix">
        <div class="post-thumb">
            <a :href="post.post_url">
                <img class="img-fluid" :src="post.photo" :alt="post.title">
            </a>
        </div>
        <a class="post-cat" :class="this.color && this.color.replace('#', 'css_')" :style="{ 'background-color': this.color }" :href="post.keywords_search_url" v-if="post.first_keyword">{{ post.first_keyword }}</a>
        <div class="post-content">
            <h2 class="post-title">
                <a :href="post.post_url" v-html="post.title"></a>
            </h2>
            <div class="post-meta">
                <span class="post-author"><a :href="post.list_url">{{ post.menu_name }}</a></span>
                <span class="post-date">{{ post.creation_date | formatShortDate }}</span>
            </div>
            <p>{{ post.short_content }}</p>
        </div><!-- Post content end -->
    </div>
</template>

<script>
    export default {
        name: 'PostSmallBlock',
        props: ['title', 'color', 'data'],
        data() {
            return {
                post: this.data ? this.data : {},
            }
        },
        watch: {
            data: function (newVal) {
                this.post = newVal;
            }
        }
    }
</script>

<style lang="scss">

    @import '~@/absctracts/variables.scss';
    @import '~@/absctracts/mixins.scss';

    #post-small-block {
        position: relative;
        overflow: hidden;

        .post-thumb {
            max-width: 100%;
            position: relative;
            overflow: hidden;
            height: 186px;

            img {
                display: block;
                width: 130% !important;
                object-fit: cover;
                -webkit-transition: all .3s ease-out;
                -o-transition: all .3s ease-out;
                transition: all .3s ease-out;
                max-width: 130%;
                height: auto;
            }

            img:hover {
                @include imgHoverScale(1.15);
            }
        }

        .post-cat {
            background: $blue;
            color: #fff;
            display: inline-block;
            font-size: 10px;
            font-weight: 700;
            height: 20px;
            margin-left: 20px;
            line-height: 20px;
            padding: 0 5px;
            position: absolute;
            text-transform: uppercase;
            top: 20px;
            z-index: 1;
        }

        .post-cat:before {
            border-top: 8px solid $blue;
            content: '';
            position: absolute;
            left: 0;
            z-index: 0;
            bottom: -8px;
            border-right: 8px solid transparent;
        }

        .post-content {
            padding: 0px;
            position: relative;
            z-index: 1;
            height: 170px;
            overflow: hidden;

            .post-title {
                font-size: 18px;
                line-height: 24px;
                margin: 15px 0 0;

                a {
                    color: $dark-grey;
                }

                a:hover {
                    color: $red;
                }
            }

            .post-meta {
                margin: 3px 0;

                span {
                    font-size: 12px;
                    color: #a3a3a3;
                    margin-right: 8px;
                    padding-right: 10px;
                    border-right: 1px solid #dedede;
                    line-height: 12px;
                    display: inline-block;
                }

                .post-author a {
                    color: $dark-grey;
                    font-weight: 700;
                }

                .post-date {
                    border-right: 0;
                }
            }

            p {
                font-size: 13px;
            }
        }
    }
</style>